import { render, staticRenderFns } from "./McrItem.vue?vue&type=template&id=f3519d12"
import script from "./McrItem.vue?vue&type=script&lang=js"
export * from "./McrItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports